import instance from './axios'
import axios from 'axios'

// 获取资产统计数据
export const getAssetStatistics = (para) => {
  return instance.post('/asset/getAssetStatistics', para, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
// 获取公司列表
export const getCompanyList = () => {
  return instance.get('/asset/getCompanyList', {}, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

// 获取资产模板
export const getAssetTemplate = () => {
  return axios.get('/louguanjia-web/open/asset/getAssetTemplate', {}, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
// 导出单户资产详情
export const exportAsset=(para)=>{  
    return axios.get('/louguanjia-web/confined/contract/exportAsset',{params:para,responseType:'arraybuffer'},{
        headers:{
            'Content-Type': 'application/vnd.ms-excel',
            
        }
    })
}
// 打印资产详情
export const printAsset=(para)=>{  
  return axios.get('/louguanjia-web/confined/contract/printAsset',{params:para,responseType:'arraybuffer'},{
      headers:{
          'Content-Type': 'application/vnd.ms-excel',
          
      }
  })
}

export const getList = (para) => {  //confined
  return instance.post('/asset/getList', para, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
export const getDefaultOptions = () => {
  return instance.get('/open/asset/getDefaultOptions', {}, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
export const addOrUpdate = (para) => {  //confined
  return instance.post('/asset/addOrUpdate', para, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
// 获取资产详情
export const getDes = (para) => {  //confined
  return instance.get('/asset/get/' + para.assetId, {}, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}


// 模板添加资产
export const addAssetByTemplate = (formdata, vm) => {
  return instance.post('/asset/addAssetByTemplate', formdata, {
    headers: {'Content-Type': 'multipart/form-data'},
    // onUploadProgress(progressEvent) {
    //   if (progressEvent.lengthComputable) {
    //     //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
    //     let rate = progressEvent.loaded / progressEvent.total;
    //     if (rate < 1) {
    //       vm.uploadRate = (rate * 100).toFixed(0);
    //     }
    //     console.log(rate)
    //   }
    // }
  })
}
// 获取上传进度
export const getUploadProcess = (para) => {  //confined
  return instance.get('/asset/getUploadProcess', {params: para}, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
// 获取合同详情列表
export const getContractDetail = (para) => {  //confined
  return instance.get('/contract/contractDetail', {params: para}, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
// 获取某个合同详情
export const contractEditDetail = (para) => {  //confined
  return instance.get('/contract/contractEditDetail', {params: para}, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
// 添加修改合同
export const addOrModContract = (para) => {  //confined
  return instance.post('/contract/addOrModContract', para, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
// 删除合同
export const removeContract=(para)=>{ 
    return axios.get('/louguanjia-web/confined/contract/removeContract',{params:para},{
        headers:{
            'Content-Type': 'application/json',
        }
    })
}
// 租金收入列表接口
export const getRentList = (para) => {  //confined
  return instance.get('/rent/rentList', {params: para}, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
// 租金收取计划提交接口
export const rentCollectionPlan = (para) => {  //confined
  return instance.post('/rent/rentCollectionPlan', para, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

// 获取转拍卖的信息
export const getInitAuction = (para) => {
  return instance.get('/switch/getInitAuction', {params: para}, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
// 获取转招商的信息
export const getInitEnrolling = (para) => {
  return instance.get('/switch/getInitEnrolling', {params: para}, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}


// 获取转拍卖模板
export const getAuctionTemplate = (para) => {
  return instance.get('/switch/getAuctionTemplate', {params: para}, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
// 获取转拍卖详情列表
export const getAuctionDetailList = (para) => {
  return instance.get('/switch/getAuctionDetailList', {params: para}, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
// 获取转招商详情列表
export const getEnrollingDetailList = (para) => {
  return instance.get('/switch/getEnrollingDetailList', {params: para}, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

// 生成转拍卖模板
export const saveAuctionTemplate = (para) => {  //confined
  return instance.post('/switch/saveAuctionTemplate', para, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
// 生成转招商模板
export const saveEnrollingTemplate = (para) => {  //confined
  return instance.post('/switch/saveEnrollingTemplate', para, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
// 根据id获取模板信心
export const getTemplateById = (para) => {  //confined
  return instance.get('/switch/getTemplateById', {params:para}, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
// 暂存/添加/更新转拍卖接口
export const saveAuction = (para) => {  //confined
  return instance.post('/switch/saveAuction', para, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
// 暂存/添加/更新转拍卖接口
export const saveEnrolling = (para) => {  //confined
  return instance.post('/switch/saveEnrolling', para, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

// 获取转招商模板
export const getEnrollingTemplate = (para) => {
  return instance.get('/switch/getEnrollingTemplate', {params: para}, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
}


// 金额格式化 千分位
export const formatMoneyThousand = (number, decimals = 2, decPoint = '.', thousandsSep = ',') => {
  number = (number + '').replace(/[^\+0-9-Ee.]/g, '')
  let n = !isFinite(+number) ? 0 : +number
  let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  let sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  let dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  let s = ''
  let toFixedFix = function (n, prec) {
    let k = Math.pow(10, prec)
    return '' + Math.ceil(n * k) / k
  }
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  let re = /(-?\d+)(\d{3})/
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2')
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return s.join(dec)
}

// 资产管理单位 
export const listToTree=function(arr){
  if(!Array.isArray(arr)) return;
  function toTree(arr,item){
    for(let i=0;i<arr.length;i++){
      if(arr[i].id === item.parentId){
        arr[i].children = arr[i].children||[];
        arr[i].children.push(item)
      }else{
        if(arr[i].children){
          toTree(arr[i].children,item)
        }
      }
    }
  }
  for(let i=0;i<arr.length;i++){
    let item=arr[i]
    if(arr[i].parentId !== -1){
      toTree(arr,item)
    }
  }
  return arr.filter(item=>item.parentId === -1)
}